module.exports = __webpack_public_path__ + "img/CIS-logo.62195f91.png";